<template>
    <div>
        <a-radio-group type="button" v-model="emailType" style="margin-bottom: 5px;" @change="changeEmailType">
            <a-radio value="internalEmail">{{ $t('config.internalEmail') }}</a-radio>
            <a-radio value="externalEmail">{{ $t('config.externalEmail') }}</a-radio>
        </a-radio-group>

        <div v-if="emailType == 'internalEmail'">
            <a-tabs :active-key="activeKey" @change="tabClick">
                <a-tab-pane key="1" :title="$t('config.dealerOverdueEmailConfig')"></a-tab-pane>
                <a-tab-pane key="2" :title="$t('config.recipientEmailConfig')"></a-tab-pane>
                <a-tab-pane key="3" :title="$t('config.CCRecipientEmailConfig')"></a-tab-pane>
                <a-tab-pane key="4" :title="$t('config.inventoryRecipientEmailConfig')"></a-tab-pane>
                <a-tab-pane key="5" :title="$t('config.saleEmailConfig')"></a-tab-pane>
                <a-tab-pane key="6" :title="$t('config.inventoryWeekTo')"></a-tab-pane>
                <a-tab-pane key="7" :title="$t('config.inventoryWeekCC')"></a-tab-pane>
            </a-tabs>

            <!-- 经销商邮箱配置 -->
            <div v-if="activeKey == 1">
                <div class="addEmailForm">
                    <Form :form="addEmailForm" :style="{display:'flex',flex:'4'}">
                        <template v-slot:formBtn>
                            <a-button v-permission="'setting.config.add'" size="small" class="form_btn" type="primary" @click="handle('add')">
                                <icon-plus-circle size="13" style="marginRight:5px;" />
                                {{ $t('base.add') }}
                            </a-button>
                            <a-divider direction="vertical" />
                            <span style="color:#165dff">{{$t('base.emailReceiveTip')}}</span>
                        </template>
                    </Form>
                    <a-input-search 
                        :style="{display:'flex',flex:'1',width:'320px',height:'30px'}" 
                        v-model="email"
                        allow-clear 
                        @press-enter="pressEnter" 
                        @search="search" 
                        @clear="pressEnter"
                        :placeholder="t('base.enterEmail')" 
                    />
                </div>
                
                <Table
                    :table="dealerTable"
                    @changePage="changePage"
                    @changePageSize="changePageSize"
                >
                    <template v-slot:tableOperate="{ props }">
                        <a-button v-permission="'setting.config.deleteEmail'" type="primary" status="danger" size="mini" @click="handle('delete',props.record)">
                            <icon-delete size="13" style="marginRight:5px;" />
                            {{ $t('order.delete') }}
                        </a-button>
                    </template>
                </Table>
            </div>

            <!-- 收件人邮箱 -->
            <div v-if="activeKey == 2">
                <div class="addEmailForm">
                    <Form :form="addEmailForm" :style="{display:'flex',flex:'4'}">
                        <template v-slot:formBtn>
                            <a-button v-permission="'setting.config.addRecipientEmail'" size="small" class="form_btn" type="primary" @click="handle('add')">
                                <icon-plus-circle size="13" style="marginRight:5px;" />
                                {{ $t('base.add') }}
                            </a-button>
                        </template>
                    </Form>
                    <a-input-search 
                        :style="{display:'flex',flex:'1',width:'320px',height:'30px'}" 
                        v-model="recipient_email"
                        allow-clear 
                        @press-enter="pressEnter" 
                        @search="search" 
                        @clear="pressEnter"
                        :placeholder="t('base.enterEmail')" 
                    />
                </div>
                
                <Table
                    :table="recipientTable"
                    @changePage="changePageRecipient"
                    @changePageSize="changePageSizeRecipient"
                >
                    <template v-slot:tableOperate="{ props }">
                        <a-button v-permission="'setting.config.deleteRecipientEmail'" type="primary" status="danger" size="mini" @click="handle('delete',props.record)">
                            <icon-delete size="13" style="marginRight:5px;" />
                            {{ $t('order.delete') }}
                        </a-button>
                    </template>
                </Table>
            </div>

            <!-- 抄送人邮箱 -->
            <div v-if="activeKey == 3">
                <div class="addEmailForm">
                    <Form :form="addEmailForm" :style="{display:'flex',flex:'4'}">
                        <template v-slot:formBtn>
                            <a-button v-permission="'setting.config.addCCRecipientEmail'" size="small" class="form_btn" type="primary" @click="handle('add')">
                                <icon-plus-circle size="13" style="marginRight:5px;" />
                                {{ $t('base.add') }}
                            </a-button>
                        </template>
                    </Form>
                    <a-input-search 
                        :style="{display:'flex',flex:'1',width:'320px',height:'30px'}" 
                        v-model="cc_email"
                        allow-clear 
                        @press-enter="pressEnter" 
                        @search="search" 
                        @clear="pressEnter"
                        :placeholder="t('base.enterEmail')" 
                    />
                </div>
                
                <Table
                    :table="CCRecipientTable"
                    @changePage="changePageCCCRecipient"
                    @changePageSize="changePageSizeCCRecipient"
                >
                    <template v-slot:tableOperate="{ props }">
                        <a-button v-permission="'setting.config.deleteCCRecipientEmail'" type="primary" status="danger" size="mini" @click="handle('delete',props.record)">
                            <icon-delete size="13" style="marginRight:5px;" />
                            {{ $t('order.delete') }}
                        </a-button>
                    </template>
                </Table>
            </div>

            <!-- 库存收件人邮箱 -->
            <div v-if="activeKey == 4">
                <div class="addEmailForm">
                    <Form :form="addEmailForm" :style="{display:'flex',flex:'4'}">
                        <template v-slot:formBtn>
                            <a-button v-permission="'setting.config.addInventoryRecipientEmail'" size="small" class="form_btn" type="primary" @click="handle('add')">
                                <icon-plus-circle size="13" style="marginRight:5px;" />
                                {{ $t('base.add') }}
                            </a-button>
                        </template>
                    </Form>
                    <a-input-search 
                        :style="{display:'flex',flex:'1',width:'320px',height:'30px'}" 
                        v-model="inventory_email"
                        allow-clear 
                        @press-enter="pressEnter" 
                        @search="search" 
                        @clear="pressEnter"
                        :placeholder="t('base.enterEmail')" 
                    />
                </div>
                
                <Table
                    :table="InventoryRecipientTable"
                    @changePage="changePageInventoryRecipient"
                    @changePageSize="changePageSizeInventoryRecipient"
                >
                    <template v-slot:tableOperate="{ props }">
                        <a-button v-permission="'setting.config.deleteInventoryRecipientEmail'" type="primary" status="danger" size="mini" @click="handle('delete',props.record)">
                            <icon-delete size="13" style="marginRight:5px;" />
                            {{ $t('order.delete') }}
                        </a-button>
                    </template>
                </Table>
            </div>

            <!-- 销售邮箱 -->
            <div v-if="activeKey == 5">
                <div class="addEmailForm">
                    <Form :form="addEmailForm" :style="{display:'flex',flex:'4'}">
                        <template v-slot:formBtn>
                            <a-button v-permission="'setting.config.addSaleEmail'" size="small" class="form_btn" type="primary" @click="handle('add')">
                                <icon-plus-circle size="13" style="marginRight:5px;" />
                                {{ $t('base.add') }}
                            </a-button>
                        </template>
                    </Form>
                    <a-input-search 
                        :style="{display:'flex',flex:'1',width:'320px',height:'30px'}" 
                        v-model="sale_email"
                        allow-clear 
                        @press-enter="pressEnter" 
                        @search="search" 
                        @clear="pressEnter"
                        :placeholder="t('base.enterEmail')" 
                    />
                </div>
                
                <Table
                    :table="saleEmailTable"
                    @changePage="changePageSaleEmail"
                    @changePageSize="changePageSizeSaleEmail"
                >
                    <template v-slot:tableOperate="{ props }">
                        <a-button v-permission="'setting.config.deleteSaleEmail'" type="primary" status="danger" size="mini" @click="handle('delete',props.record)">
                            <icon-delete size="13" style="marginRight:5px;" />
                            {{ $t('order.delete') }}
                        </a-button>
                    </template>
                </Table>
            </div>

            <!-- 库存周报收件人邮箱 -->
            <div v-if="activeKey == 6">
                <div class="addEmailForm">
                    <Form :form="addEmailForm" :style="{display:'flex',flex:'4'}">
                        <template v-slot:formBtn>
                            <a-button v-permission="'setting.config.addInventoryWeekEmail'" size="small" class="form_btn" type="primary" @click="handle('add')">
                                <icon-plus-circle size="13" style="marginRight:5px;" />
                                {{ $t('base.add') }}
                            </a-button>
                        </template>
                    </Form>
                    <a-input-search 
                        :style="{display:'flex',flex:'1',width:'320px',height:'30px'}" 
                        v-model="inventory_week_to_email"
                        allow-clear 
                        @press-enter="pressEnter" 
                        @search="search" 
                        @clear="pressEnter"
                        :placeholder="t('base.enterEmail')" 
                    />
                </div>
                
                <Table
                    :table="inventoryWeekToEmailTable"
                    @changePage="changePageInventoryWeekToEmail"
                    @changePageSize="changePageSizeInventoryWeekToEmail"
                >
                    <template v-slot:tableOperate="{ props }">
                        <a-button v-permission="'setting.config.deleteInventoryWeekEmail'" type="primary" status="danger" size="mini" @click="handle('delete',props.record)">
                            <icon-delete size="13" style="marginRight:5px;" />
                            {{ $t('order.delete') }}
                        </a-button>
                    </template>
                </Table>
            </div>

            <!-- 库存周报抄送人邮箱 -->
            <div v-if="activeKey == 7">
                <div class="addEmailForm">
                    <Form :form="addEmailForm" :style="{display:'flex',flex:'4'}">
                        <template v-slot:formBtn>
                            <a-button v-permission="'setting.config.addInventoryWeekEmail'" size="small" class="form_btn" type="primary" @click="handle('add')">
                                <icon-plus-circle size="13" style="marginRight:5px;" />
                                {{ $t('base.add') }}
                            </a-button>
                        </template>
                    </Form>
                    <a-input-search 
                        :style="{display:'flex',flex:'1',width:'320px',height:'30px'}" 
                        v-model="inventory_week_cc_email"
                        allow-clear 
                        @press-enter="pressEnter" 
                        @search="search" 
                        @clear="pressEnter"
                        :placeholder="t('base.enterEmail')" 
                    />
                </div>
                
                <Table
                    :table="inventoryWeekCCEmailTable"
                    @changePage="changePageInventoryWeekCCEmail"
                    @changePageSize="changePageSizeInventoryWeekCCEmail"
                >
                    <template v-slot:tableOperate="{ props }">
                        <a-button v-permission="'setting.config.deleteInventoryWeekEmail'" type="primary" status="danger" size="mini" @click="handle('delete',props.record)">
                            <icon-delete size="13" style="marginRight:5px;" />
                            {{ $t('order.delete') }}
                        </a-button>
                    </template>
                </Table>
            </div>
        </div>
        <div v-else>
            <a-tabs :active-key="activeKey_external" @change="tabClick">
                <a-tab-pane key="8" :title="$t('config.inventoryWeeklyReport')"></a-tab-pane>
                <a-tab-pane key="9" :title="$t('config.inventoryWeeklyReportBCC')"></a-tab-pane>
            </a-tabs>
            <!-- 外部邮件-库存周报邮箱收件人 -->
            <div v-if="activeKey_external == 8">
                <div class="addEmailForm">
                    <Form :form="addEmailForm" :style="{display:'flex',flex:'4'}">
                        <template v-slot:formBtn>
                            <!-- setting.config.addInventoryWeeklyReportEmail -->
                            <a-button v-permission="'setting.config.addInventoryWeekEmail'" size="small" class="form_btn" type="primary" @click="handle('add')">
                                <icon-plus-circle size="13" style="marginRight:5px;" />
                                {{ $t('base.add') }}
                            </a-button>
                        </template>
                    </Form>
                    <a-input-search 
                        :style="{display:'flex',flex:'1',width:'320px',height:'30px'}" 
                        v-model="inventory_weekly_report_email"
                        allow-clear 
                        @press-enter="pressEnter" 
                        @search="search" 
                        @clear="pressEnter"
                        :placeholder="t('base.enterEmail')" 
                    />
                </div>
                
                <Table
                    :table="inventoryWeeklyReportEmailTable"
                    @changePage="changePageInventoryWeeklyReportEmail"
                    @changePageSize="changePageSizeInventoryWeeklyReportEmail"
                >
                    <template v-slot:tableOperate="{ props }">
                        <!-- setting.config.deleteInventoryWeeklyReportEmail -->
                        <a-button v-permission="'setting.config.deleteInventoryWeekEmail'" type="primary" status="danger" size="mini" @click="handle('delete',props.record)">
                            <icon-delete size="13" style="marginRight:5px;" />
                            {{ $t('order.delete') }}
                        </a-button>
                    </template>
                </Table>
            </div>
            <div v-if="activeKey_external == 9">
                <div class="addEmailForm">
                    <Form :form="addEmailForm" :style="{display:'flex',flex:'4'}">
                        <template v-slot:formBtn>
                            <!-- setting.config.addInventoryWeeklyReportCCEmail -->
                            <a-button v-permission="'setting.config.addInventoryWeekEmail'" size="small" class="form_btn" type="primary" @click="handle('add')">
                                <icon-plus-circle size="13" style="marginRight:5px;" />
                                {{ $t('base.add') }}
                            </a-button>
                        </template>
                    </Form>
                    <a-input-search 
                        :style="{display:'flex',flex:'1',width:'320px',height:'30px'}" 
                        v-model="inventory_weekly_report_email_cc"
                        allow-clear 
                        @press-enter="pressEnter" 
                        @search="search" 
                        @clear="pressEnter"
                        :placeholder="t('base.enterEmail')" 
                    />
                </div>
                
                <Table
                    :table="inventoryWeeklyReportCCEmailTable"
                    @changePage="changePageInventoryWeeklyReportCCEmail"
                    @changePageSize="changePageSizeInventoryWeeklyReportCCEmail"
                >
                    <template v-slot:tableOperate="{ props }">
                        <!-- setting.config.deleteInventoryWeeklyReportCCEmail -->
                        <a-button v-permission="'setting.config.deleteInventoryWeekEmail'" type="primary" status="danger" size="mini" @click="handle('delete',props.record)">
                            <icon-delete size="13" style="marginRight:5px;" />
                            {{ $t('order.delete') }}
                        </a-button>
                    </template>
                </Table>
            </div>
        </div>
        
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch } from 'vue';
    import { BaseApi } from '@/api/BaseApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { AddEmailForm } from './queryConfig/AddForm.js';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n()

    const emailType = ref('internalEmail')
    const activeKey = ref(1)
    const activeKey_external = ref(8)
    const addEmailForm = reactive(AddEmailForm)
    const email = ref('')
    const recipient_email = ref('')
    const cc_email = ref('')
    const inventory_email = ref('')
    const sale_email = ref('')
    const inventory_week_to_email = ref('')
    const inventory_week_cc_email = ref('')
    const inventory_weekly_report_email = ref('')
    const inventory_weekly_report_email_cc = ref('')
    // 经销商逾期邮箱配置
    const dealerTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'100',
                align:'center',
            },
            {
                // title: '邮箱',
                title:t('config.dealerOverdueEmail'),
                dataIndex: 'email',
                key:'email',
                // width:'230',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '操作',
                title:t('order.operate'),
                dataIndex: 'Optional',
                key: 'Optional',
                slotName: 'optional',
                width: '200',
                align: 'center',
                // fixed: 'right'
            }   
        ],
        configs:{
            scroll:{
                // x:1000,
                // y:700,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })
    // KPI日报收件人
    const recipientTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'100',
                align:'center',
            },
            {
                // title: '邮箱',
                title:t('config.recipientEmail'),
                dataIndex: 'email',
                key:'email',
                // width:'230',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '操作',
                title:t('order.operate'),
                dataIndex: 'Optional',
                key: 'Optional',
                slotName: 'optional',
                width: '200',
                align: 'center',
                // fixed: 'right'
            }   
        ],
        configs:{
            scroll:{
                // x:1000,
                // y:700,
            },
            stripe:true,
            bordered:false,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })
    // KPI日报收件人和抄送人
    const CCRecipientTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'100',
                align:'center',
            },
            {
                // title: '邮箱',
                title:t('config.CCRecipientEmail'),
                dataIndex: 'email',
                key:'email',
                // width:'230',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '操作',
                title:t('order.operate'),
                dataIndex: 'Optional',
                key: 'Optional',
                slotName: 'optional',
                width: '200',
                align: 'center',
                // fixed: 'right'
            }   
        ],
        configs:{
            scroll:{
                // x:1000,
                // y:700,
            },
            stripe:true,
            bordered:false,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })
    // 库存收件人
    const InventoryRecipientTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'100',
                align:'center',
            },
            {
                // title: '邮箱',
                title:t('config.recipientEmail'),
                dataIndex: 'email',
                key:'email',
                // width:'230',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '操作',
                title:t('order.operate'),
                dataIndex: 'Optional',
                key: 'Optional',
                slotName: 'optional',
                width: '200',
                align: 'center',
                // fixed: 'right'
            }   
        ],
        configs:{
            scroll:{
                // x:1000,
                // y:700,
            },
            stripe:true,
            bordered:false,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })
    // 销售邮箱
    const saleEmailTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'100',
                align:'center',
            },
            {
                // title: '邮箱',
                title:t('config.recipientEmail'),
                dataIndex: 'email',
                key:'email',
                // width:'230',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '操作',
                title:t('order.operate'),
                dataIndex: 'Optional',
                key: 'Optional',
                slotName: 'optional',
                width: '200',
                align: 'center',
                // fixed: 'right'
            }   
        ],
        configs:{
            scroll:{
                // x:1000,
                // y:700,
            },
            stripe:true,
            bordered:false,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })
    // 库存周报收件人
    const inventoryWeekToEmailTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'100',
                align:'center',
            },
            {
                // title: '邮箱',
                title:t('config.recipientEmail'),
                dataIndex: 'email',
                key:'email',
                // width:'230',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '操作',
                title:t('order.operate'),
                dataIndex: 'Optional',
                key: 'Optional',
                slotName: 'optional',
                width: '200',
                align: 'center',
                // fixed: 'right'
            }   
        ],
        configs:{
            scroll:{
                // x:1000,
                // y:700,
            },
            stripe:true,
            bordered:false,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })
    // 库存周报抄送人
    const inventoryWeekCCEmailTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'100',
                align:'center',
            },
            {
                // title: '邮箱',
                title:t('config.ccEmail'),
                dataIndex: 'email',
                key:'email',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '操作',
                title:t('order.operate'),
                dataIndex: 'Optional',
                key: 'Optional',
                slotName: 'optional',
                width: '200',
                align: 'center',
            }   
        ],
        configs:{
            scroll:{
                // x:1000,
                // y:700,
            },
            stripe:true,
            bordered:false,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })
    // 库存周报邮箱收件人-外部
    const inventoryWeeklyReportEmailTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'100',
                align:'center',
            },
            {
                // title: '邮箱',
                title:t('base.email'),
                dataIndex: 'email',
                key:'email',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '操作',
                title:t('order.operate'),
                dataIndex: 'Optional',
                key: 'Optional',
                slotName: 'optional',
                width: '200',
                align: 'center',
            }   
        ],
        configs:{
            scroll:{
                // x:1000,
                // y:700,
            },
            stripe:true,
            bordered:false,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })
    // 库存周报邮箱抄送人-外部
    const inventoryWeeklyReportCCEmailTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'100',
                align:'center',
            },
            {
                // title: '邮箱',
                title:t('base.email'),
                dataIndex: 'email',
                key:'email',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '操作',
                title:t('order.operate'),
                dataIndex: 'Optional',
                key: 'Optional',
                slotName: 'optional',
                width: '200',
                align: 'center',
            }   
        ],
        configs:{
            scroll:{
                // x:1000,
                // y:700,
            },
            stripe:true,
            bordered:false,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })

    const changeEmailType = (val)=>{
        console.log(val,'type')
        if(val == 'internalEmail'){
            activeKey.value = 1
            addEmailForm.formData.email = ''
            email.value = ''
            getList()
        }else{
            activeKey.value = ''
            addEmailForm.formData.email = ''
            inventory_weekly_report_email.value = ''
            getInventoryWeeklyReportList()
        }
    }

    const tabClick = (val)=>{
        console.log(val,'vvgg')
        if(emailType.value == 'internalEmail') activeKey.value = val
        if(emailType.value == 'externalEmail') activeKey_external.value = val
        addEmailForm.formData.email = ''

        email.value = ''
        recipient_email.value = ''
        cc_email.value = ''
        inventory_email.value = ''
        sale_email.value = ''
        inventory_week_to_email.value = ''
        inventory_week_cc_email.value = ''
        inventory_weekly_report_email.value = ''
        inventory_weekly_report_email_cc.value = ''

        // 内部邮件
        if(val == 2 || val == 3) getRecipienOrCCEmailList()
        if(val == 4) getInventoryRecipientList()
        if(val == 5) getSaleEmailList()
        if(val == 6 || val == 7) getInventoryWeekEmailList()

        // 外部邮件
        if(val == 8) getInventoryWeeklyReportList()
        if(val == 9) getInventoryWeeklyReportCCList()
    }

    const handle = (type,row)=>{
        switch(type){
            case 'add':
                let pattern = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,}$/
                let bool = pattern.test(addEmailForm.formData.email)
                if(!addEmailForm.formData.email){
                    Message.error(t('setting.emailMsg'))
                    return
                }
                if(!bool){
                    Message.error(t('setting.emailFormat'))
                    return
                }

                // 内部
                if(activeKey.value == 1) save()
                else if(activeKey.value == 2 || activeKey.value == 3) saveRecipienOrCCEmail()
                else if(activeKey.value == 4) saveInventoryRecipient()
                else if(activeKey.value == 5) saveSaleEmail()
                else if(activeKey.value == 6 || activeKey.value == 7) saveInventoryWeekEmail()

                // 外部
                else if(activeKey_external.value == 8) saveInventoryWeeklyReportEmail() 
                else if(activeKey_external.value == 9) saveInventoryWeeklyReportCCEmail() 
                break;
            case 'delete':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    hideCancel:false,
                    content: t('base.delConfirmTip'),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        del(row)
                    }
                });
                break;
        }
    }

    const pressEnter = ()=>{
        // 内部
        if(activeKey.value == 1){
            dealerTable.value.configs.pagination.current = 1
            getList()
        }else if(activeKey.value == 2){
            recipientTable.value.configs.pagination.current = 1
            getRecipienOrCCEmailList()
        }else if(activeKey.value == 3){
            CCRecipientTable.value.configs.pagination.current = 1
            getRecipienOrCCEmailList()
        }else if(activeKey.value == 4){
            InventoryRecipientTable.value.configs.pagination.current = 1
            getInventoryRecipientList()
        }else if(activeKey.value == 5){
            saleEmailTable.value.configs.pagination.current = 1
            getSaleEmailList()
        }else if(activeKey.value == 6){
            inventoryWeekToEmailTable.value.configs.pagination.current = 1
            getInventoryWeekEmailList()
        }else if(activeKey.value == 7){
            inventoryWeekCCEmailTable.value.configs.pagination.current = 1
            getInventoryWeekEmailList()
        }

        // 外部
        else if(activeKey_external.value == 8){
            inventoryWeeklyReportEmailTable.value.configs.pagination.current = 1
            getInventoryWeeklyReportList()
        }else if(activeKey_external.value == 9){
            inventoryWeeklyReportCCEmailTable.value.configs.pagination.current = 1
            getInventoryWeeklyReportCCList()
        }
    }

    const search = (val)=>{
        email.value = val

        if(activeKey.value == 1){
            dealerTable.value.configs.pagination.current = 1
            getList()
        }else if(activeKey.value == 2){
            recipientTable.value.configs.pagination.current = 1
            getRecipienOrCCEmailList()
        }else if(activeKey.value == 3){
            CCRecipientTable.value.configs.pagination.current = 1
            getRecipienOrCCEmailList()
        }else if(activeKey.value == 4){
            InventoryRecipientTable.value.configs.pagination.current = 1
            getInventoryRecipientList()
        }else if(activeKey.value == 5){
            saleEmailTable.value.configs.pagination.current = 1
            getSaleEmailList()
        }else if(activeKey.value == 6){
            inventoryWeekToEmailTable.value.configs.pagination.current = 1
            getInventoryWeekEmailList()
        }else if(activeKey.value == 7){
            inventoryWeekCCEmailTable.value.configs.pagination.current = 1
            getInventoryWeekEmailList()
        }

        else if(activeKey_external.value == 8){
            inventoryWeeklyReportEmailTable.value.configs.pagination.current = 1
            getInventoryWeeklyReportList()
        }else if(activeKey_external.value == 9){
            inventoryWeeklyReportCCEmailTable.value.configs.pagination.current = 1
            getInventoryWeeklyReportCCList()
        }
    }

    const changePage = (current)=>{
        dealerTable.value.configs.pagination.current = current
        getList()
    }

    const changePageSize = (pageSize)=>{
        dealerTable.value.configs.pagination.current = 1
        dealerTable.value.configs.pagination.pageSize = pageSize
        getList()
    }

    const changePageRecipient = (current)=>{
        recipientTable.value.configs.pagination.current = current
        getRecipienOrCCEmailList()
    }

    const changePageSizeRecipient = (pageSize)=>{
        recipientTable.value.configs.pagination.current = 1
        recipientTable.value.configs.pagination.pageSize = pageSize
        getRecipienOrCCEmailList()
    }

    const changePageCCRecipient = (current)=>{
        CCRecipientTable.value.configs.pagination.current = current
        getRecipienOrCCEmailList()
    }

    const changePageSizeCCRecipient = (pageSize)=>{
        CCRecipientTable.value.configs.pagination.current = 1
        CCRecipientTable.value.configs.pagination.pageSize = pageSize
        getRecipienOrCCEmailList()
    }

    const changePageInventoryRecipient = (current)=>{
        InventoryRecipientTable.value.configs.pagination.current = current
        getInventoryRecipientList()
    }

    const changePageSizeInventoryRecipient = (pageSize)=>{
        InventoryRecipientTable.value.configs.pagination.current = 1
        InventoryRecipientTable.value.configs.pagination.pageSize = pageSize
        getInventoryRecipientList()
    }

    const changePageSaleEmail = (current)=>{
        saleEmailTable.value.configs.pagination.current = current
        getSaleEmailList()
    }

    const changePageSizeSaleEmail = (pageSize)=>{
        saleEmailTable.value.configs.pagination.current = 1
        saleEmailTable.value.configs.pagination.pageSize = pageSize
        getSaleEmailList()
    }

    const changePageInventoryWeekToEmail = (current)=>{
        inventoryWeekToEmailTable.value.configs.pagination.current = current
        getInventoryWeekEmailList()
    }

    const changePageSizeInventoryWeekToEmail = (pageSize)=>{
        inventoryWeekToEmailTable.value.configs.pagination.current = 1
        inventoryWeekToEmailTable.value.configs.pagination.pageSize = pageSize
        getInventoryWeekEmailList()
    }

    const changePageInventoryWeekCCEmail = (current)=>{
        inventoryWeekCCEmailTable.value.configs.pagination.current = current
        getInventoryWeekEmailList()
    }

    const changePageSizeInventoryWeekCCEmail = (pageSize)=>{
        inventoryWeekCCEmailTable.value.configs.pagination.current = 1
        inventoryWeekCCEmailTable.value.configs.pagination.pageSize = pageSize
        getInventoryWeekEmailList()
    }

    const changePageInventoryWeeklyReportEmail = (current)=>{
        inventoryWeeklyReportEmailTable.value.configs.pagination.current = current
        getInventoryWeeklyReportList()
    }

    const changePageSizeInventoryWeeklyReportEmail = (pageSize)=>{
        inventoryWeeklyReportEmailTable.value.configs.pagination.current = 1
        inventoryWeeklyReportEmailTable.value.configs.pagination.pageSize = pageSize
        getInventoryWeeklyReportList()
    }

    const changePageInventoryWeeklyReportCCEmail = (current)=>{
        inventoryWeeklyReportCCEmailTable.value.configs.pagination.current = current
        getInventoryWeeklyReportCCList()
    }

    const changePageSizeInventoryWeeklyReportCCEmail = (pageSize)=>{
        inventoryWeeklyReportCCEmailTable.value.configs.pagination.current = 1
        inventoryWeeklyReportCCEmailTable.value.configs.pagination.pageSize = pageSize
        getInventoryWeeklyReportCCList()
    }

    // 获取dealer邮箱列表
    const getList = async ()=>{
        let param = {
            dict_code: "send_email", 
            dict_sub_code:'finance_nopaid',
            dict_sub_name:email.value,
        }
        let page_num = dealerTable.value.configs.pagination.current
        let page_size = dealerTable.value.configs.pagination.pageSize
        dealerTable.value.configs.loading = true

        let res = await BaseApi.getInstance().getSOSyncList(param,page_num,page_size)
        if(res.code == 0){
            dealerTable.value.datas = []
            res.data.records.forEach((i,index)=>{
                dealerTable.value.datas.push({
                    No:index + 1,
                    id:i.id,
                    email:i.dict_sub_name,
                })
            })
            dealerTable.value.configs.pagination.total = res.data.total
            dealerTable.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取收件人/抄送人邮箱列表
    const getRecipienOrCCEmailList = async ()=>{
        let param = {
            dict_code: "send_email", 
            dict_sub_code:activeKey.value == 2? 'daily_report_to' : 'daily_report_cc',
            dict_sub_name:activeKey.value == 2? recipient_email.value : cc_email.value,
        }

        let table = activeKey.value == 2? recipientTable.value :CCRecipientTable.value
        let page_num = table.configs.pagination.current
        let page_size = table.configs.pagination.pageSize
        table.configs.loading = true

        let res = await BaseApi.getInstance().getSOSyncList(param,page_num,page_size)
        if(res.code == 0){
            table.datas = []
            res.data.records.forEach((i,index)=>{
                table.datas.push({
                    No:index + 1,
                    id:i.id,
                    email:i.dict_sub_name,
                })
            })
            table.configs.pagination.total = res.data.total
            table.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取库存收件人邮箱列表
    const getInventoryRecipientList = async ()=>{
        let param = {
            dict_code: "send_email", 
            dict_sub_code:'inventory_to',
            dict_sub_name:inventory_email.value,
        }
        let page_num = InventoryRecipientTable.value.configs.pagination.current
        let page_size = InventoryRecipientTable.value.configs.pagination.pageSize
        InventoryRecipientTable.value.configs.loading = true

        let res = await BaseApi.getInstance().getSOSyncList(param,page_num,page_size)
        if(res.code == 0){
            InventoryRecipientTable.value.datas = []
            res.data.records.forEach((i,index)=>{
                InventoryRecipientTable.value.datas.push({
                    No:index + 1,
                    id:i.id,
                    email:i.dict_sub_name,
                })
            })
            InventoryRecipientTable.value.configs.pagination.total = res.data.total
            InventoryRecipientTable.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取销售邮箱列表
    const getSaleEmailList = async ()=>{
        let param = {
            dict_code: "send_email", 
            dict_sub_code:'dealer_credit_fail_to',
            dict_sub_name:sale_email.value,
        }
        let page_num = saleEmailTable.value.configs.pagination.current
        let page_size = saleEmailTable.value.configs.pagination.pageSize
        saleEmailTable.value.configs.loading = true

        let res = await BaseApi.getInstance().getSOSyncList(param,page_num,page_size)
        if(res.code == 0){
            saleEmailTable.value.datas = []
            res.data.records.forEach((i,index)=>{
                saleEmailTable.value.datas.push({
                    No:index + 1,
                    id:i.id,
                    email:i.dict_sub_name,
                })
            })
            saleEmailTable.value.configs.pagination.total = res.data.total
            saleEmailTable.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取库存周报收件人/抄送人列表
    const getInventoryWeekEmailList = async ()=>{
        let param = {
            dict_code: "send_email", 
            dict_sub_code: activeKey.value == 6? 'inventory_week_to' : 'inventory_week_cc',
            dict_sub_name: activeKey.value == 6? inventory_week_to_email.value : inventory_week_cc_email.value,
        }

        let table = activeKey.value == 6? inventoryWeekToEmailTable.value : inventoryWeekCCEmailTable.value
        let page_num = table.configs.pagination.current
        let page_size = table.configs.pagination.pageSize
        table.configs.loading = true

        let res = await BaseApi.getInstance().getSOSyncList(param,page_num,page_size)
        if(res.code == 0){
            table.datas = []
            res.data.records.forEach((i,index)=>{
                table.datas.push({
                    No:index + 1,
                    id:i.id,
                    email:i.dict_sub_name,
                })
            })
            table.configs.pagination.total = res.data.total
            table.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取库存周报收件人列表-外部
    const getInventoryWeeklyReportList = async ()=>{
        let param = {
            dict_code: "send_email", 
            dict_sub_code: 'inventory_week_out_to',
            dict_sub_name: inventory_weekly_report_email.value,
        }

        let table = inventoryWeeklyReportEmailTable.value
        let page_num = table.configs.pagination.current
        let page_size = table.configs.pagination.pageSize
        table.configs.loading = true

        let res = await BaseApi.getInstance().getSOSyncList(param,page_num,page_size)
        if(res.code == 0){
            table.datas = []
            res.data.records.forEach((i,index)=>{
                table.datas.push({
                    No:index + 1,
                    id:i.id,
                    email:i.dict_sub_name,
                })
            })
            table.configs.pagination.total = res.data.total
            table.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取库存周报抄送人列表-外部
    const getInventoryWeeklyReportCCList = async ()=>{
        let param = {
            dict_code: "send_email", 
            dict_sub_code: 'inventory_week_out_bcc',
            dict_sub_name: inventory_weekly_report_email_cc.value,
        }

        let table = inventoryWeeklyReportCCEmailTable.value
        let page_num = table.configs.pagination.current
        let page_size = table.configs.pagination.pageSize
        table.configs.loading = true

        let res = await BaseApi.getInstance().getSOSyncList(param,page_num,page_size)
        if(res.code == 0){
            table.datas = []
            res.data.records.forEach((i,index)=>{
                table.datas.push({
                    No:index + 1,
                    id:i.id,
                    email:i.dict_sub_name,
                })
            })
            table.configs.pagination.total = res.data.total
            table.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 保存dealer邮箱
    const save = async ()=>{
        let param = {
            dict_code: "send_email", 
            dict_sub_code:'finance_nopaid',
            dict_sub_value:addEmailForm.formData.email,
            dict_sub_name:addEmailForm.formData.email
        }
        let res = await BaseApi.getInstance().saveSOSync(param)
        if(res.code == 0){
            Message.success(t('base.addSuccess'))
            addEmailForm.formData.email = ''
            getList()
        }else{
            Message.error(res.msg)
        }
    }

    // 保存收件人、抄送人邮箱
    const saveRecipienOrCCEmail = async ()=>{
        let param = {
            dict_code: "send_email", 
            dict_sub_code: activeKey.value == 2? 'daily_report_to' : 'daily_report_cc',
            dict_sub_value:addEmailForm.formData.email,
            dict_sub_name:addEmailForm.formData.email
        }
        let res = await BaseApi.getInstance().saveSOSync(param)
        if(res.code == 0){
            Message.success(t('base.addSuccess'))
            addEmailForm.formData.email = ''
            getRecipienOrCCEmailList()
        }else{
            Message.error(res.msg)
        }
    }

    // 保存库存收件人邮箱
    const saveInventoryRecipient = async ()=>{
        let param = {
            dict_code: "send_email", 
            dict_sub_code:'inventory_to',
            dict_sub_value:addEmailForm.formData.email,
            dict_sub_name:addEmailForm.formData.email
        }
        let res = await BaseApi.getInstance().saveSOSync(param)
        if(res.code == 0){
            Message.success(t('base.addSuccess'))
            addEmailForm.formData.email = ''
            getInventoryRecipientList()
        }else{
            Message.error(res.msg)
        }
    }

    // 保存销售邮箱
    const saveSaleEmail = async ()=>{
        let param = {
            dict_code: "send_email", 
            dict_sub_code:'dealer_credit_fail_to',
            dict_sub_value:addEmailForm.formData.email,
            dict_sub_name:addEmailForm.formData.email
        }
        let res = await BaseApi.getInstance().saveSOSync(param)
        if(res.code == 0){
            Message.success(t('base.addSuccess'))
            addEmailForm.formData.email = ''
            getSaleEmailList()
        }else{
            Message.error(res.msg)
        }
    }

    // 保存库存周报收件人、抄送人邮箱
    const saveInventoryWeekEmail = async ()=>{
        let param = {
            dict_code: "send_email", 
            dict_sub_code: activeKey.value == 6? 'inventory_week_to' : 'inventory_week_cc',
            dict_sub_value:addEmailForm.formData.email,
            dict_sub_name:addEmailForm.formData.email
        }
        let res = await BaseApi.getInstance().saveSOSync(param)
        if(res.code == 0){
            Message.success(t('base.addSuccess'))
            addEmailForm.formData.email = ''
            getInventoryWeekEmailList()
        }else{
            Message.error(res.msg)
        }
    }

    // 保存库存周报收件人邮箱-外部
    const saveInventoryWeeklyReportEmail = async ()=>{
        let param = {
            dict_code: "send_email", 
            dict_sub_code:'inventory_week_out_to',
            dict_sub_value:addEmailForm.formData.email,
            dict_sub_name:addEmailForm.formData.email
        }
        let res = await BaseApi.getInstance().saveSOSync(param)
        if(res.code == 0){
            Message.success(t('base.addSuccess'))
            addEmailForm.formData.email = ''
            getInventoryWeeklyReportList()
        }else{
            Message.error(res.msg)
        }
    }

    // 保存库存周报抄送人邮箱-外部
    const saveInventoryWeeklyReportCCEmail = async ()=>{
        let param = {
            dict_code: "send_email", 
            dict_sub_code:'inventory_week_out_bcc',
            dict_sub_value:addEmailForm.formData.email,
            dict_sub_name:addEmailForm.formData.email
        }
        let res = await BaseApi.getInstance().saveSOSync(param)
        if(res.code == 0){
            Message.success(t('base.addSuccess'))
            addEmailForm.formData.email = ''
            getInventoryWeeklyReportCCList()
        }else{
            Message.error(res.msg)
        }
    }

    // 删除dealer邮箱，收件人邮箱，抄送人邮箱
    const del = async (row)=>{
        let res = await BaseApi.getInstance().delSOSync(row.id)
        if(res.code == 0){
            Message.success(t('base.delSuccess'))
            if(activeKey.value == 1) getList()
            else if(activeKey.value == 2 || activeKey.value == 3) getRecipienOrCCEmailList()
            else if(activeKey.value == 4) getInventoryRecipientList()
            else if(activeKey.value == 5) getSaleEmailList()
            else if(activeKey.value == 6 || activeKey.value == 7) getInventoryWeekEmailList()

            else if(activeKey_external.value == 8) getInventoryWeeklyReportList()
            else if(activeKey_external.value == 9) getInventoryWeeklyReportCCList()
        }else{
            Message.error(res.msg)
        }
    }

    onMounted(()=>{
        getList()
    })
</script>

<style lang="less" scoped>
/deep/ .arco-tabs-nav-tab{
    background:#fff;
    padding-left: 8px;
}
/deep/ .arco-tabs-content{
    padding-top:6px;
}

.addEmailForm{
    display: flex;
    background: #fff;
    padding: 10px 20px 0px 20px;

    .form_btn{
        margin-left: -100px;
    }
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    padding: 3px 0;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/ .arco-input-wrapper .arco-input[disabled] {
    -webkit-text-fill-color: #999;
}

/deep/ .arco-form-item-layout-inline{
    margin-right:0;
}

/deep/ .arco-radio-button.arco-radio-checked{
    color: #fff;
    background: #165dff;
}

/deep/ .arco-radio-group-button{
    background: #e7e7e7;
}
</style>